{
  "bg-BG": {
    "model": {
      "profile": {
        "id": "Идентификатор на потребителя",
        "userName": "Потребителско име",
        "email": "Имейл адрес",
        "emailConfirmed": "Имейл адресът е потвърден.",
        "phoneNumber": "Телефонен номер",
        "phoneNumberConfirmed": "Телефонният номер е потвърден.",
        "twoFactorEnabled": "Активирана е двуфакторна автентификация.",
        "lockoutEnd": "Край на блокирането",
        "lockoutEnabled": "Активирана е функцията за блокиране.",
        "accessFailedCount": "Брой неуспешни опити за достъп.",
        "firstName": "Име",
        "lastName": "Фамилия",
        "picture": "Снимка за профила",
        "organisationName": "Организация",
        "name": "Име",
        "roles": "Роли"
      }
    },
    "profileManager": {
      "column": {
        "emailConfirmed": "Потвърден"
      },
      "action": {
        "resetPassword.tooltip": "Изпратете инструкции за възстановяване на паролата на потребителя по имейл."
      },
      "message": {
        "resetPassword.success": "Изпратен е имейл до потребителя с инструкции как да възстанови паролата си."
      }
    }
  }
}